{
  "destinationSearch": {
    "calendarButton": "#View dates#",
    "fromOrigin": "from {origin}"
  },
  "timetable": {
    "panel": {
      "title": "Timetable",
      "departure": "Departure",
      "return": "Return",
      "bookFlights": "Book flights"
    },
    "flightList": {
      "selectDepartureDate": "Select a departure date to see the timetable.",
      "selectReturnDate": "Select a return date to see the timetable."
    }
  },
  "bookingSearch": {
    "errors": {
      "noResults": {
        "noFlightsFound": "Sorry, we couldn't find any flights",
        "noFlightsAvailable": "Sorry, there are no flights available"
      },
      "actions": {
        "reloadPage": "Reload this page",
        "toFrontPage": "Go to front page"
      }
    }
  },
  "serviceForms": {
    "refundsCompensations": {
      "continue": "Continue",
      "newCase": "Create new case",
      "viewCase": "View existing cases",
      "infoAccordion": [
        {
          "title": "Eligible refund and compensation cases",
          "content": "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Sed posuere interdum sem. Quisque ligula eros ullamcorper quis, lacinia quis facilisis sed sapien."
        },
        {
          "title": "Documents needed for submitting a claim",
          "content": "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Sed posuere interdum sem. Quisque ligula eros ullamcorper quis, lacinia quis facilisis sed sapien."
        },
        {
          "title": "Gift voucher benefits",
          "content": "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Sed posuere interdum sem. Quisque ligula eros ullamcorper quis, lacinia quis facilisis sed sapien."
        }
      ]
    },
    "specialAssistanceWizard": {
      "infoAccordion": [
        {
          "title": "Accordion title 1",
          "content": "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Sed posuere interdum sem. Quisque ligula eros ullamcorper quis, lacinia quis facilisis sed sapien."
        },
        {
          "title": "Accordion title 2",
          "content": "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Sed posuere interdum sem. Quisque ligula eros ullamcorper quis, lacinia quis facilisis sed sapien."
        },
        {
          "title": "Accordion title 3",
          "content": "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Sed posuere interdum sem. Quisque ligula eros ullamcorper quis, lacinia quis facilisis sed sapien."
        }
      ]
    },
    "fields": {
      "preorderBagNumber": {
        "label": " Preorder Bag Number",
        "placeholder": "E.g. 6291015"
      }
    }
  },
  "ticketSelection": {
    "travelClassAlternative": "We could not find any flights with your selected travel class, so here are some other alternatives."
  },
  "loginPromotion": {
    "greeting": {
      "text": {
        "inPaxDetails": "We pre-filled your details based on your account. Take a moment to check them.",
        "inPaxDetailsMulti": "We pre-filled your details based on your account. Please check them, then add the details for the other passengers."
      }
    }
  },
  "indiaRedirectNotification": "Hi! We redirected you to our international site from the Indian country site, which is temporarily closed for enhancements. You can book flights and use our services on this site as you would on the Indian one. We are sorry for any inconvenience.",
  "ondMarketing": {
    "breadcrumb": {
      "flights": "Flights",
      "fromCity": "From cities",
      "cityToCity": "City to city",
      "fromCountry": "From countries",
      "countryToCountry": "Country to country"
    },
    "heading": {
      "flights": "Discover our flights and routes",
      "fromCity": "Flights from cities",
      "cityToCity": "Explore more flights and destinations",
      "fromCountry": "Flights from countries",
      "countryToCountry": "Explore more flights and destinations"
    },
    "flightsFrom": "Flights from {origin}",
    "promotionButtonText": "Read more",
    "destinationFlightInfo": {
      "startingFrom": "Starting from",
      "roundTrip": "Round-trip",
      "oneWay": "One-way",
      "flightTime": "Flight time",
      "approx": "Approx.",
      "airports": "Airports",
      "directFlights": "Direct flights",
      "frequency": {
        "unit": {
          "day": "/ day",
          "week": "/ week"
        },
        "perDay": {
          "singular": "1 flight / day",
          "plural": "{count} flights / day"
        },
        "perWeek": {
          "singular": "1 flight / week",
          "plural": "{count} flights / week"
        }
      }
    },
    "fromTo": "{origin}–{destination}"
  },
  "travelType": {
    "from": {
      "oneWay": "One way from",
      "return": "Round trip from"
    }
  }
}
